import React from 'react';
import { Control, Controller, FieldValues } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormControl } from '@mui/material';
import { DateWithInfinityFieldType } from '@/type';
import { VALID_TO_INFINITE } from '@/constant';
import InfinityDateInput from '../../input/InfinityDateInput';

interface DateWithInfinityControllerProps<
  TFieldValues extends FieldValues = FieldValues,
> {
  control: Control<TFieldValues>;
  disabled: boolean;
  dateWithInfinityField: DateWithInfinityFieldType;
}

const DateWithInfinityController = <TFieldValues extends FieldValues = FieldValues>({
  control,
  disabled,
  dateWithInfinityField,
}: DateWithInfinityControllerProps<TFieldValues>) => {
  const { t } = useTranslation();

  function formatDateValue(value: unknown): string {
    if (typeof value === 'string') {
      return value.split('T')[0];
    }
    return '';
  }

  return (
    <Controller
      name={dateWithInfinityField.name as any}
      control={control}
      defaultValue={(dateWithInfinityField.defaultValue as any) || ''}
      render={({ field }) => {
        const dateValue = formatDateValue(field.value);
        const isIndefinite = dateValue === VALID_TO_INFINITE;

        return (
          <FormControl fullWidth>
            <InfinityDateInput
              value={dateValue}
              label={t(dateWithInfinityField.label)}
              isIndefinite={isIndefinite}
              onClear={() => field.onChange(new Date().toISOString().split('T')[0])}
              onSetInfinite={() => field.onChange(VALID_TO_INFINITE)}
              onChange={(value) => field.onChange(value)}
              required={dateWithInfinityField.required}
              disabled={disabled || dateWithInfinityField.disabled}
            />
          </FormControl>
        );
      }}
    />
  );
};

export default DateWithInfinityController;
